import { DETAILIZATION_TABS } from '../constants';

export const detailizationByKey = (activeTab) => {
    return DETAILIZATION_TABS.find((item) => item.key === activeTab).id;
};
